import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import MyDashboard from "../MyDashboard/MyDashboard";
import SRUDashboard from "../SRU/SRUDashboard/SRUDashboard";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import SRUNavBarHeader from "../SRU/SRUNavBarHeader/SRUNavBarHeader";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import TranslationFile from "../../Pages/15-Translation/locale/Translation_apps.json";
// import Sidebar from "../PlayGroundtesting/PlayGroundtesting";
import Sidebar from "../MainSideBar/MainSideBar";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
let userSessionAuthKey = setUserSessionAuthKey();
let userSelectedLanguage;
const MainDashboard = () => {
  const history = useHistory();

  let appName = localStorage.getItem("appType");

  const [activeIndex, setActiveIndex] = useState(
    appName == null || appName == "Annual Report" ? 0 : 1
  );
  const [config, setConfig] = useState({
    Skatteverket: null
  });

  const [sideBarStatus, setSideBarStatus] = useState(true);

  useEffect(() => {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    if (appName == "Annual Report") {
      setActiveIndex(0);
    } else if (appName == "Income Declaration") {
      setActiveIndex(1);
    }
  }, []);

  const navigateTo = (e) => {
    if (e == "Annual Report") {
      setActiveIndex(0);
    } else if (e == "Income Declaration 2") {
      setActiveIndex(1);
    }
  };

  const sideBarStatusFnc = (e) => {
    setSideBarStatus(e);
  };

  const callback = (annualReport, session, link, status) => {
    let sessionUUIDFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      history.push(annualReport + sessionUUIDFromLS + link);
    }
  };

  return (
    <div className="card">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {userSelectedLanguage == "sw"
            ? TranslationFile.FaviconAppText[userSelectedLanguage]
            : TranslationFile.FaviconAppText.en}
        </title>
      </Helmet>
      <Sidebar
        navigateTo={navigateTo}
        children={activeIndex === 0 ? "Annual Report" : "Income Declaration 2"}
        sideBarStatus={(e) => sideBarStatusFnc(e)}
      />
      {/* Render NavBarHeader for AnnualReport Dashboard and SRUNavBarHeader for SRU Dashboard */}
      {activeIndex === 0 && (
        <div>
          <NavBarHeader
            isAppPortal={true}
            isHomePage={false}
            callBack={callback}
          />
          <div style={{ marginLeft: sideBarStatus ? "0%" : "-11%" }}>
            <MyDashboard />
          </div>
        </div>
      )}
      {activeIndex === 1 && (
        <div>
          <SRUNavBarHeader
            isAppPortal={true}
            isHomePage={false}
            callBack={callback}
          />
          <div style={{ marginLeft: sideBarStatus ? "0%" : "-11%" }}>
            <SRUDashboard />
          </div>
        </div>
      )}

      {/* <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ marginTop: "4%", marginLeft: "4%" }}>
                <TabPanel header="AnnualReport Dashboard">
                    <MyDashboard />
                </TabPanel>
                <TabPanel header="SRU Dashboard">
                    <SRUDashboard />
                </TabPanel>
            </TabView> */}
    </div>
  );
};

export default MainDashboard;
